import type { OakStreamOptions } from "./types";

export function createStreamHash({
  url,
  initialLastEventId,
}: Pick<OakStreamOptions, "url" | "initialLastEventId">) {
  return JSON.stringify({
    initialLastEventId,
    hasInitialLastEventId: initialLastEventId !== undefined,
    url,
  });
}
